import script from "./TeacherDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./TeacherDetailsModal.vue?vue&type=style&index=0&id=b9540e48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9540e48"]])

export default __exports__